import { Proposal, Quote } from '@lockton-apps/shared/interfaces';
import { compact, has, map, toString } from 'lodash';

export function getProposalUrl(
  source: Quote | Proposal | undefined | null,
  stepId?: string
): string[] {
  if (!source) {
    return [];
  }

  return isQuote(source)
    ? buildUrlFromQuote(source, stepId)
    : buildUrlFromProposal(source, stepId);
}

function buildUrlFromQuote(quote: Quote, stepId?: string): string[] {
  return compact(
    map(
      [
        '/proposals',
        quote.portalId,
        quote.proposal?.subType || 1,
        quote.clientId,
        quote.propFormId,
        stepId,
      ],
      toString
    )
  );
}

function buildUrlFromProposal(proposal: Proposal, stepId?: string): string[] {
  return compact(
    map(
      [
        '/proposals',
        proposal.portalId,
        proposal.subType || 1,
        proposal.clientId,
        proposal.id,
        stepId,
      ],
      toString
    )
  );
}

function isQuote(source: unknown): source is Quote {
  return has(source, 'propFormId');
}
